import React from "react"
import { User } from "../../ZeefTypes"

interface MentionDropdownProps {
  suggestions: User[]
  onSelect: (user: User) => void
}

const MentionDropdown: React.FC<MentionDropdownProps> = ({ suggestions, onSelect }) => (
  <div className="mention-dropdown">
    {suggestions.map((user) => (
      <div key={user.id} className="mention-suggestion" onClick={() => onSelect(user)}>
        <div className="user-avatar-small">{user.username.substring(0, 2).toUpperCase()}</div>
        <div className="user-details-small">
          <div className="user-name-small">@{user.username}</div>
          <div className="user-email-small">{user.email}</div>
        </div>
      </div>
    ))}
  </div>
)

export default MentionDropdown
